import React from 'react';
import styles from './PanelButtonDivider.scss';
const PanelButtonDivider = () => <div className={styles.divider}/>;
export default PanelButtonDivider;
